import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { Router } from '@angular/router';
import { FieldType } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectsFacade } from 'src/app/core/store/projects/projects.facade';
import { ToFixedPipe } from './to-fixed.pipe';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent extends FieldType implements AfterViewInit {
  focused = false;
  isLot = false;

  constructor(
    private router: Router,
    private projectsFacade: ProjectsFacade,
    private toFixedPipe: ToFixedPipe
  ) {
    super();

    this.isLot = this.router.url.includes('?lot=true');
  }

  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  ngAfterViewInit(): void {
    const key = this?.field?.key as string;
    // const value = this.isFloat(this.model[key])
    //   ? Math.round(this.model[key])
    //   : this.model[key];
    const value = this.toFixedPipe.transform(this.model[key]);
    this.model[key] = value;
    this.formControl.setValue(value);
  }

  get highlightBorderColor(): Observable<string> {
    return this.projectsFacade.city$.pipe(
      map((city) => {
        const hasAgeWarning =
          city === 'CRICIÚMA' || city === 'BALNEÁRIO RINCÃO';
        return hasAgeWarning && this.isLot && this.key === 'Idade'
          ? '#2E64E6'
          : '';
      })
    );
  }
}
